import React from "react";

const Service = () => {
  // const services = [
  //   {
  //     id: 1,
  //     name: "Therapists",
  //     icon: (
  //       <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 20 20">
  //         <path
  //           fill="#2BEAD2"
  //           d="M7.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 6a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Zm-1-11a.5.5 0 0 0-.5.5V3h-.5A1.5 1.5 0 0 0 4 4.5v12A1.5 1.5 0 0 0 5.5 18h5.867a3.18 3.18 0 0 1-.329-1H5.5a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v4.541a3.02 3.02 0 0 1 1 0V4.5A1.5 1.5 0 0 0 14.5 3H14v-.5a.5.5 0 0 0-1 0V3h-2.5v-.5a.5.5 0 0 0-1 0V3H7v-.5a.5.5 0 0 0-.5-.5Zm9 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.255 3.5-2.5a1.5 1.5 0 0 0-1.5-1.5h-4a1.5 1.5 0 0 0-1.5 1.5c0 1.25 1 2.5 3.5 2.5Zm-8-9a.5.5 0 0 0 0 1H11a.5.5 0 0 0 0-1H7.5Z"
  //         />
  //       </svg>
  //     ),
  //     text:
  //       "Over 100 seasoned experts dedicated to supporting individuals in improving their mental health and emotional well-being.",
  //   },
  //   {
  //     id: 2,
  //     name: "Psychiatrists",
  //     icon: (
  //       <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
  //         <path fill="#2BEAD2" d="M241.063 54.406c..." />
  //       </svg>
  //     ),
  //     text:
  //       "Skilled psychiatrists provide focused 30-minute consultations to offer you the support you need and enhance your quality of life.",
  //   },
  //   {
  //     id: 3,
  //     name: "Counsellors",
  //     icon: (
  //       <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 26 24">
  //         <path fill="#2BEAD2" d="M22.313 17.295a7.436 7.436..." />
  //       </svg>
  //     ),
  //     text:
  //       "Counsellors are trained professionals who help offering guidance to achieve mental clarity, self-awareness.",
  //   },
  // ];
const services = [
    {
      id: 1,
      name: "Therapists",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 20 20"
        >
          <path
            fill="#2BEAD2"
            d="M7.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 6a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Zm-1-11a.5.5 0 0 0-.5.5V3h-.5A1.5 1.5 0 0 0 4 4.5v12A1.5 1.5 0 0 0 5.5 18h5.867a3.18 3.18 0 0 1-.329-1H5.5a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v4.541a3.02 3.02 0 0 1 1 0V4.5A1.5 1.5 0 0 0 14.5 3H14v-.5a.5.5 0 0 0-1 0V3h-2.5v-.5a.5.5 0 0 0-1 0V3H7v-.5a.5.5 0 0 0-.5-.5Zm9 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.255 3.5-2.5a1.5 1.5 0 0 0-1.5-1.5h-4a1.5 1.5 0 0 0-1.5 1.5c0 1.25 1 2.5 3.5 2.5Zm-8-9a.5.5 0 0 0 0 1H11a.5.5 0 0 0 0-1H7.5Z"
          />
        </svg>
      ),
      text:
        "Over 100 seasoned experts dedicated to supporting individuals in improving their mental health and emotional well-being.",
    },
    {
      id: 2,
      name: "Psychiatrists",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 512 512"
        >
          <path
            fill="#2BEAD2"
            d="M241.063 54.406a293.615 293.615 0 0 0-12.313.282c-8.814 1.567-12.884 5.426-15.094 9.843c-2.435 4.87-2.34 11.423.375 17.25c2.717 5.83 7.7 10.596 14.657 12.376c6.958 1.78 16.536.86 29.125-7.187l10.063 15.75c-15.818 10.11-31.124 12.777-43.813 9.53c-12.688-3.247-22.103-12.123-26.968-22.563c-4.584-9.836-5.426-21.376-1.03-31.624c-42.917 6.94-81.777 23.398-111.626 46.562c-9.81 10.688-10.77 23.11-6.47 31.594c4.83 9.526 16.21 16.48 38.97 9.28l5.656 17.813c-28.58 9.04-52.137-.588-61.28-18.625c-2.23-4.397-3.592-9.156-4.127-14.063c-4.814 5.712-9.16 11.658-13 17.844l.126.06c-8.614 19.616-8.81 33.203-5.376 42.032c3.436 8.83 10.635 14.44 21.72 17.532c22.168 6.18 58.065-1.277 83.343-20.156c10.82-8.08 21.077-27.677 21.97-42.875c.445-7.6-1.165-13.604-4.345-17.438c-3.18-3.834-8.272-6.703-18.813-6.594l-.187-18.686c14.487-.15 26.25 4.754 33.375 13.344c7.124 8.59 9.26 19.652 8.625 30.468c-1.27 21.633-12.595 44.172-29.438 56.75c-29.876 22.314-69.336 31.606-99.53 23.188c-13.988-3.9-26.37-12.386-32.75-25.53c-9.546 45.446 4.323 87.66 30.718 116.874c3.45 3.82 7.122 7.43 10.97 10.78c-2.754-7.887-4.016-16.1-3.72-24.093c.53-14.325 6.082-28.346 17.22-38.03c9.134-7.946 21.752-12.53 36.843-12.5c1.006 0 2.034.018 3.062.06c2.35.1 4.763.304 7.22.626l-2.44 18.532c-15.588-2.048-25.705 1.522-32.436 7.375c-6.73 5.854-10.443 14.614-10.813 24.625c-.74 20.024 12.07 43.406 39.69 50.188l-.032.188c27.192 5.19 57.536.372 88-18.22c.018-.012.043-.017.062-.03c6.34-4.45 9.755-8.808 11.438-12.563c1.985-4.432 1.943-8.292.53-12.438c-2.824-8.29-12.94-16.812-22.218-19.187c-15.002-3.84-24.532 1.436-29 7.72c-4.468 6.28-4.74 12.45 2.156 17.81l-11.47 14.75c-14.187-11.033-15.092-30.487-5.905-43.405c6.892-9.688 18.985-16.326 33.564-16.75a46.963 46.963 0 0 1 1.844-.03c4.306.03 8.79.622 13.437 1.81c15.505 3.97 29.84 15.277 35.28 31.25a36.189 36.189 0 0 1 1.876 13.314c16.71-8.538 34.332-16.12 52.282-21.814c30.156-13.78 43.23-37.938 42.72-58.28c-.515-20.493-13.187-37.74-42.376-40.626l1.844-18.594c36.666 3.626 58.462 29.848 59.188 58.75c.422 16.84-5.754 34.363-18.188 49.28c16.072-1.8 32.044-1.495 47.53 1.627c-3.152-6.472-4.68-13.478-4.467-20.438c.677-22.036 19.42-42.593 48.875-42.906a66.155 66.155 0 0 1 6.03.218l-1.5 18.625c-24.927-1.998-34.3 11.086-34.718 24.656c-.412 13.42 8.545 28.442 34.22 30.436c28.3.25 48.588-15.098 58.53-37.906c13.31-30.536 6.997-76.317-34.844-118.188c-.792-.793-1.578-1.593-2.375-2.375a40.42 40.42 0 0 1-2.842 10.844c-7.25 17.39-24.233 29.128-41.875 32.407c-24.335 4.522-44.29-5.347-53.5-20.406c-9.21-15.057-6.792-36.35 9.78-47.56l10.47 15.5c-8.913 6.028-9.28 14.19-4.313 22.31c4.967 8.122 16.17 15.156 34.156 11.814c11.306-2.102 23.896-11.33 28.03-21.25c2.07-4.96 2.47-9.862.408-15.47c-1.675-4.555-5.187-9.764-11.72-15.25l-.187-.155c-27.316-20.587-56.338-35.393-85.75-45.157c.018.032.045.06.063.093c6.684 12.22 7.18 26.082 3.063 38.344c-8.233 24.525-34.07 43.848-66.032 42.78c-6.948-.23-13.56 3.12-19.186 9.657c-5.627 6.537-9.735 16.113-10.688 26.313c-1.905 20.4 6.923 42.886 41.344 54L277 258.28c-41.083-13.264-56.83-45.546-54.22-73.5c1.307-13.975 6.706-26.962 15.157-36.78c8.452-9.818 20.475-16.603 33.97-16.156c24.04.802 42.323-14.084 47.687-30.063c2.682-7.988 2.335-15.937-1.75-23.405c-3.968-7.252-11.83-14.423-25.906-19.656a292.57 292.57 0 0 0-50.875-4.314zM342.28 306.344c-41.915 3.41-87.366 23.4-125.28 46.562c-55.98 34.198-114.89 26.733-156.688-4.28c16.444 58.844 74.712 70.788 135.5 55.905c6.083-2.285 12.06-6.538 17.157-12.03c7.057-7.607 12.17-17.47 13.78-25.625l18.344 3.625c-2.445 12.383-9.078 24.666-18.406 34.72c-8.95 9.645-20.61 17.35-34.094 19.374c-6.766 15.07-12.334 29.68-14.594 39.906c-3.55 16.06 14.206 22.225 22.156 6.03c19.022-38.743 45.87-73.23 79.406-102.967c26.064-17.153 48.406-38.303 62.72-61.22z"
          />
        </svg>
      ),
      text:
        "Skilled psychiatrists provide focused 30-minute consultations to offer you the support you need and enhance your quality of life.",
    },
    {
      id: 3,
      name: "Counsellors",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 26 24"
        >
          <path
            fill="#2BEAD2"
            d="M22.313 17.295a7.436 7.436 0 0 0-4.089-2.754l-.051-.011l-1.179 1.99a1.003 1.003 0 0 1-1 1c-.55 0-1-.45-1.525-1.774v-.032a1.25 1.25 0 1 0-2.5 0v.033v-.002c-.56 1.325-1.014 1.774-1.563 1.774a1.003 1.003 0 0 1-1-1l-1.142-1.994a7.47 7.47 0 0 0-4.126 2.746l-.014.019a4.475 4.475 0 0 0-.655 2.197v.007c.005.15 0 .325 0 .5v2a2 2 0 0 0 2 2h15.5a2 2 0 0 0 2-2v-2c0-.174-.005-.35 0-.5a4.522 4.522 0 0 0-.666-2.221l.011.02zM7.968 5.29c0 2.92 1.82 7.21 5.25 7.21c3.37 0 5.25-4.29 5.25-7.21v-.065a5.25 5.25 0 1 0-10.5 0v.068zm11.234 1.72c0 1.902 1.186 4.698 3.42 4.698c2.195 0 3.42-2.795 3.42-4.698v-.052a3.421 3.421 0 0 0-6.842 0v.055v-.003zm-19.2 1.6c0 1.902 1.186 4.698 3.42 4.698c2.195 0 3.42-2.795 3.42-4.698v-.052a3.421 3.421 0 0 0-6.842 0v.055v-.003z"
          />
        </svg>
      ),
      text:
        "Counsellors are trained professionals who help   offering guidance to achieve mental clarity, self-awareness.",
    },
    
  ];
  return (
    <div className="py-10 px-4 sm:px-6 md:px-[5%] bg-gradient-to-t from-[#f7f7fe] to-[#f5f5ff]">
      <div className="flex flex-col items-center text-center">
        <h3 className="bg-primary/20 text-lg text-accent px-3 py-1 rounded-3xl">
          Our Services
        </h3>
        <h2 className="mt-5 text-2xl sm:text-3xl md:text-4xl text-primaraytext font-bold">
          Connect with caring <span className="text-accent font-serif">mental health</span> professionals
        </h2>
        <p className="text-base sm:text-lg mt-3 text-primaraytext max-w-3xl">
          All providers at Mindcare complete a rigorous vetting process and are highly qualified and experienced.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {services.map(({ id, name, icon, text }) => (
          <div
            key={id}
            className="p-5 bg-white text-center rounded-lg border hover:card-shadow border-t-4 border-white hover:border-t-accent"
            data-aos="fade-up"
          >
            <div className="flex justify-center items-center w-16 h-16 mx-auto rounded-full bg-primary/20 text-primary hover:bg-primary hover:text-white transition">
              {icon}
            </div>
            <h3 className="mt-4 text-xl font-semibold text-primaraytext">{name}</h3>
            <p className="mt-2 text-sm text-gray-600 mb-3">{text}</p>
            <a href="#" className="text-accent hover:underline text-sm">
              View All
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
